import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ResetPasswordComponent from "../../components/layout/ResetPassword/ResetPassword";
import Button from "../../components/common/Button/Button";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ResetPassword.scss";
import { getApiInstance, initializeApi } from "../../utils/api";

const ResetPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState(null);
    const [isValidToken, setIsValidToken] = useState(true);

    async function CheckForgotToken (tokenToCheck) {
        try {
        await initializeApi();
        const api = getApiInstance();
        const formData = new URLSearchParams();
        formData.append("token", tokenToCheck);

        var response = await api.post("api/Auth/CheckForgotPasswordToken", formData, {
            headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            },
        });

        if(response.status !== 200) {
            console.log("Token inválido");
            setIsValidToken(false);
            return;
        }

        console.log("Token válido");
        
        setIsValidToken(true);

        } catch (err) {
            console.log("Token inválido - catch");
            console.log(err);
        setIsValidToken(false);}
        finally {
        }
    }


useEffect(() => {
    const tokenParam = searchParams.get("token");

    if (!tokenParam) {
        setIsValidToken(false);
        return;
    }

    setToken(tokenParam);

    const checkToken = async () => {
        await CheckForgotToken(tokenParam); // <-- le pasamos el token directamente
    };

    checkToken();

}, [searchParams]);

    const handleSuccess = () => {
        navigate("/login");
    };

    const handleCancel = () => {
        navigate("/login");
    };

    if (!isValidToken) {
        return (
            <div className="reset-password-page">
                <div className="reset-password-page__container">
                    <div className="reset-password-page__invalid">
                        <FaExclamationTriangle className="reset-password-page__invalid__icon" />
                        <h2>{t("resetPassword.invalidTokenTitle")}</h2>
                        <p>{t("resetPassword.invalidTokenMessage")}</p>
                        <Button
                            variant="filled"
                            onClick={() => navigate("/login")}
                        >
                            {t("resetPassword.backToLogin")}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    if (!token) {
        return (
            <div className="reset-password-page">
                <div className="reset-password-page__container">
                    <div className="reset-password-page__loading">
                        {t("common.loading")}...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="reset-password-page">
            <div className="reset-password-page__container">
                <ResetPasswordComponent
                    token={token}
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
};

export default ResetPassword;
